import frontImage from "./icons/FrontPage.jpg";

const FrontPage = ({height, width}) => {
    return(
        <img src = {frontImage} style={{height: height, width: width, objectFit: 'cover'}}/>
    )
}
export default FrontPage;